
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class CqbyTable extends Vue {
    //传奇霸业
    table = {
        data: [],
        column: [
            {
                title: '底分',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).Base) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).Base)
                    } else if (JSON.parse(params.row.opt_detail).point) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).point)
                    } else {
                        str = '/'
                    }
                    return h('span', str)
                }
            },
            {
                title: '中奖倍数',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).rate) {
                        str = JSON.parse(params.row.opt_detail).rate
                    } else if ((str = JSON.parse(params.row.opt_detail).Rate)) {
                        str = JSON.parse(params.row.opt_detail).Rate
                    } else {
                        str = '/'
                    }
                    return h('span', str)
                }
            },
            {
                title: '当局图案及顺序',
                align: 'center',
                render: (h, params) => {
                    let arr = []
                    if (JSON.parse(params.row.opt_detail).Award) {
                        arr = JSON.parse(params.row.opt_detail).Award[1]
                    }
                    return h('div', {
                        style: {
                            marginTop: '5px'
                        },
                        domProps: {
                            innerHTML: arr.map((item, i) => {
                                return "<img style='width:35px;' src=img/gameImg/cqby/" + item + '.png>'
                            })
                        }
                    })
                }
            }
        ]
    }

    @Prop()
    listdata
}
